import qs from 'qs';
import { handleActions } from 'redux-actions';

import endpoints from '../../../config/endpoints';
import { regions } from '../../../../../../enums/regions';

import { LOCATION_CHANGE, replace } from 'react-router-redux';

import http from '../../shared/http';
import intl from '../../shared/intl';
import checkPermissions from '../../shared/check-permissions';

import moment from 'moment';

import cloneDeep from 'lodash/cloneDeep';
import createFilters from '../../shared/fixed-filters';

import {default as createCalendar, getDateRangeFromCalendar} from '../../shared/calendar';

const calendar = createCalendar({
	namespace: 'riskPayouts',
	stateNodeName: 'calendar',
	defaultValue: {
		start: moment().subtract(1, 'month').format('YYYY-MM-DD'),
		end: moment().format('YYYY-MM-DD')
	}
});

const filters = createFilters({
	namespace: 'riskPayouts',
	stateNodeName: 'filters',
	queryBuildFunc: () => '',
	listOfFilters: [{
		name: 'affiliates',
		title: 'Affiliates',
		placeholder: 'Add affiliates',
		value: [],
		multi: true,
		shouldInverse: false,
		shouldShowInverseControl: false,
		options: {
			type: 'dynamic',
			source: endpoints.LOOKUPS.AFFILIATES
		}
	}, {
		name: 'managers',
		title: 'Managers',
		placeholder: 'Add managers',
		value: [],
		multi: true,
		shouldInverse: false,
		shouldShowInverseControl: false,
		options: {
			type: 'dynamic',
			source: endpoints.LOOKUPS.ADMINS
		}
	}, 		{
		name: 'offers',
		title: 'Offers',
		placeholder: 'Add offers',
		value: [],
		multi: true,
		shouldInverse: false,
		shouldShowInverseControl: false,
		options: {
			type: 'dynamic',
			source: endpoints.LOOKUPS.OFFERS
		}
	},
	{
		name: 'country_ids',
		title: 'Countries',
		placeholder: 'Add country',
		value: [],
		multi: true,
		shouldInverse: false,
		shouldShowInverseControl: false,
		options: {
			type: 'dynamic',
			source: endpoints.LOOKUPS.LOCATIONS_WITH_TRAFFIC,
			params: 'limit=100'
		}
	},

	{
		name: 'niches',
		title: 'Niches',
		placeholder: 'Select niches',
		value: [],
		multi: true,
		shouldInverse: false,
		shouldShowInverseControl: false,
		options: {
			type: 'dynamic',
			source: endpoints.LOOKUPS.OFFERS_NICHES
		}
	},		{
		name: 'has_traffic',
		title: 'Has traffic',
		placeholder: 'Has traf?',
		value: [],
		multi: true,
		searchable: false,
		shouldInverse: false,
		shouldShowInverseControl: false,
		options: {
			type: 'provided',
			source: [true, false].map(reg => ({
				value: reg,
				label: `${reg}`
			}))
		}
	}, {
		name: 'regions',
		title: 'Regions',
		placeholder: 'Add regions',
		value: [],
		multi: true,
		shouldInverse: false,
		shouldShowInverseControl: true,
		options: {
			type: 'provided',
			source: regions.map(reg => ({
				value: reg,
				label: reg
			}))
		}
	}]
});

// action types
const FETCH_DATA_SUCCESS = 'riskPayouts/fetch-data-success';
const FETCH_DATA_ERROR = 'riskPayouts/fetch-data-error';

const REQUEST_SUCCESS = 'riskPayouts/REQUEST_SUCCESS';
const REQUEST_ERR = 'riskPayouts/REQUEST_ERR';

const TOGGLE_PROGRESS_BAR = 'riskPayouts/toggle-progress-bar';

const PAGINATE = 'riskPayouts/PAGINATE';
const CLEAR_PAGINATION = 'riskPayouts/CLEAR_PAGINATION';
const TOGGLE_SORT = 'riskPayouts/TOGGLE_SORT';
const CONCAT_DATA = 'riskPayouts/CONCAT_DATA';
const REMOVE_SHOW_MORE = 'riskPayouts/REMOVE_SHOW_MORE';

const APPLY = 'riskPayouts/apply';
const CHANGE_CHECKED_STATUS = 'riskPayouts/CHANGE_CHECKED_STATUS';

// permissions
export const allowedPermissions = {
	payout_requests_personal_view: 'payout_requests_personal_view',
	payout_requests_view_all: 'payout_requests_view_all',
	payout_requests_review: 'payout_requests_review',
	payout_requests_view_matrix_and_history: 'payout_requests_view_matrix_and_history',
	payout_requests_manager_role: 'payout_requests_manager_role',
	payout_requests_confirm: 'payout_requests_confirm'
};

const table = {
	columns: {
		id_created_at_manager: { index: 'id', className: '', title: 'ID & Created at & Manager' },
		aff_off_geo: { index: 'aff_off_geo', className: '', title: 'Aff & Off & Geo' },
		camp_id: { index: 'camp_id', className: '', title: 'CAMP ID & SID' },
		new_payout: { index: 'new_payout', className: '', title: 'New payout' },
		traffic_source: { index: 'traffic_source', className: '', title: 'Traffic source'},
		after_confirm_count: {
			index: 'after_review_count', className: 'sort-header', title: 'Leads after confirm', direction: 'desc'
		},
		checked_at: { index: 'checked_at', className: '', title: 'Checking date' },
		actions: { index: 'actions', className: '', title: 'Check' }
	}
};
// initial state
const initialState = {
	data: null,
	systemBalances: {},
	calendar: calendar.initialState,
	table,
	showProgressBar: false,
	filters: filters.initialState,
	error: false,
	pagination: {
		limit: 100000,
		offset: 0
	},
	sort: {
		index: null,
		direction: null
	},
	isRequestFormVisible: false,
	isShowMoreVisible: true,
	sortedPayoutSystemsList: []
};

// actions
export const actions = Object.assign(
	{
		fetchData: () => (dispatch, getState) => {
			dispatch(actions.toggleProgressBar());
			dispatch({ type: CLEAR_PAGINATION });

			const query = getQuery(getState);

			return http({
				url: `${endpoints.PAYOUT_REQUESTS.BASE}/risky?${qs.stringify(query)}`,
				method: 'get',
				actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
			})(dispatch);
		},
		sortData: (col) => (dispatch, getState) => {
			dispatch({ type: TOGGLE_SORT, payload: col });
			return dispatch(actions.fetchData());
		},
		concatPaginatedData: () => (dispatch, getState) => {
			// dispatch(actions.toggleProgressBar());
			dispatch({ type: PAGINATE });

			const query = getQuery(getState);

			return http({
				url: `${endpoints.PAYOUT_REQUESTS.BASE}/risky?${qs.stringify(query)}`,
				method: 'get',
				actions: [CONCAT_DATA, FETCH_DATA_ERROR]
			})(dispatch)
				.then(action => {
					if (action.type === CONCAT_DATA && action.payload.data.length === 0) {
						dispatch({ type: REMOVE_SHOW_MORE });
					}
				});
		},
		markChecked: (id, is_good = false) => (dispatch, getState) => {
			return http({
				url: `${endpoints.PAYOUT_REQUESTS.BASE}/${id}/risky/${is_good ? 'good' : 'bad'}`,
				method: 'put',
				actions: [REQUEST_SUCCESS, REQUEST_ERR]
			})(dispatch)
				.then((action) => {
					if (action.type === REQUEST_SUCCESS) {
						dispatch(actions.changeCheckedStatus(id, is_good));
					}
				});
		},

		apply: () => dispatch => {
			dispatch(actions.fetchData());
		},

		changeCheckedStatus: (id, is_checked_good = false) => (dispatch) => {
			dispatch({ type: CHANGE_CHECKED_STATUS, payload: { is_checked_good, id }});
		},

		clear: () => (dispatch, getState) => {
			dispatch(replace('/payouts/'));
		},
		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		})
	},
	calendar.actions,
	filters.actions
);

const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => {
			return initialState;
		},
		[FETCH_DATA_SUCCESS]: (state, action) => {
			return {
				...state,
				data: action.payload.data,
				showProgressBar: false,
				error: false
			};
		},
		[CONCAT_DATA]: (state, action) => {
			return {
				...state,
				data: [...state.data, ...action.payload.data],
				showProgressBar: false,
				error: false
			};
		},
		[APPLY]: (state, action) => {
			return {
				...state,
				selectedFilters: {
					...action.payload
				}
			};
		},
		[FETCH_DATA_ERROR]: state => ({ ...state, error: true, showProgressBar: false }),
		[CHANGE_CHECKED_STATUS]: (state, action) => ({
			...state,
			data: [...state.data].map(item => {
				if (item.id === action.payload.id) {
					item.is_checked_good = action.payload.is_checked_good;
				}
				return item;
			})
		}),
		[PAGINATE]: state => ({ ...state, pagination: {
			...state.pagination, offset: state.pagination.limit + state.pagination.offset
		}}),
		[CLEAR_PAGINATION]: state => ({ ...state, pagination: {...initialState.pagination} }),
		[TOGGLE_SORT]: (state, action) => ({ ...state, sort: {
			index: action.payload,
			direction: action.payload !== state.sort.index || state.sort.direction === 'desc' ? 'asc' : 'desc'
		}}),
		[REMOVE_SHOW_MORE]: state => ({ ...state, isShowMoreVisible: false }),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar })
	},
	calendar.reducers,
	filters.reducers
);

// reducers
export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.riskPayouts.data,
	getPagination: state => state.riskPayouts.pagination,
	getSort: state => state.riskPayouts.sort,
	getIsShowMoreVisible: state => state.riskPayouts.isShowMoreVisible,
	getCalendar: state => calendar.selectors.getCalendar(
		state => state.riskPayouts.calendar, state => state
	)(state),
	getProgressBar: state => state.riskPayouts.showProgressBar,
	getTable: state => {
		const { table, data } = state.riskPayouts;
		return {
			headers: Object.values(table.columns),
			rows: data || []
		};
	},
	getIsRequestFormVisible: state => state.riskPayouts.isRequestFormVisible,
	getIntl: state => intl(state),
	getCan: state => checkPermissions(state, allowedPermissions),
	getFilters: state => filters.selectors.getFilters(
		state => state.riskPayouts.filters,
		state => state
	)(state),
	getRequestFormInitialValues: state => ({
		currency: 'usd'
	}),
	getError: state => state.riskPayouts.error
};

function getQuery(getState) {

	const query = {filters: {}};
	const { calendar, filters: { selectedFilters }, sort } = getState().riskPayouts;
	query.date_range = getDateRangeFromCalendar(calendar);
	query.pagination = selectors.getPagination(getState());
	query.sort = [ sort.index, sort.direction ];

	if (selectedFilters) {
		selectedFilters.forEach(filter => {
			const values = filter.value.map(f => f.value);
			if (values.length) {
				query.filters[filter.name] = values;
			}
		});
	}
	return query;
}


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/risk-payouts/index.js